export default {
  Inactive: 'BillingProviderSubscriptionNotActive',
  IsInTrialPeriod: 'BillingProviderSubscriptionIsInTrialPeriod',
  IsInFirstPeriod: 'BillingProviderSubscriptionIsInFirstPeriod',
  AlreadyAdjustedInCurrentPeriod: 'BillingProviderSubscriptionAlreadyAdjustedInCurrentPeriod',
};
